var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotGroup)?_c('div',[_c('span',{staticClass:"font-weight-bold body-1"},[_vm._v(_vm._s(_vm.fullName))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }